module.exports = __webpack_public_path__ + "public/img/ico-wifi-encrypted.b068c765.svg";